import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SalesService } from 'src/app/services/sales.service';

@Component({
  selector: 'app-sales-channel-invoice-status',
  templateUrl: './sales-channel-invoice-status.component.html',
  styleUrls: ['./sales-channel-invoice-status.component.css']
})
export class SalesChannelInvoiceStatusComponent implements OnInit {

  api_error: any;
  api_success: string;
  rep_status: string;
  statusTo: string;
  disableConfirmbtn = false;
  rep_id: any;
  constructor(private dialogRef: MatDialogRef<any>,
     @Inject(MAT_DIALOG_DATA) public data: any,
      private salesService: SalesService) { }

  ngOnInit() {
    this.rep_status = this.data['salesRep'].repStatus;
    this.rep_id = this.data['salesRep'].id;
    if (this.rep_status === 'ACTIVE') {
      this.statusTo = 'INACTIVE';
    } else {
      this.statusTo = 'ACTIVE';
    }
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onConfirm() {

  }
}

